var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mmmm"},[_c('h1',[_vm._v("主页")])])])
}]

export { render, staticRenderFns }